import { ImageGallery, ImageCard, ImageFrame, ImageCaption } from "../report/Styles";

// Shared rendering for inline report images (e.g. §3 cartography), reused by the
// user-interface and admin BlockRenderers so the gallery markup + styles live in
// one place. Each item is an already-resolved image file source (signed href +
// label + the `cadastral:<view>` id). Non-image sources (e.g. the floor-
// distribution PDF) are not passed here — they render as attachment pills.
const IMAGE_FILE_RE = /\.(png|jpe?g|webp|gif|svg|bmp|tiff?)$/i;

export const isImageFile = (name?: string): boolean => !!name && IMAGE_FILE_RE.test(name);

export interface CartographyImageItem {
  href?: string;
  label?: string;
  id?: string;
}

export const CartographyImages = ({ images }: { images: CartographyImageItem[] }) => {
  if (!images || images.length === 0) return null;
  return (
    <ImageGallery>
      {images.map((e, i) => (
        <ImageCard key={`img-${i}`}>
          <ImageFrame>
            <img src={e.href} alt={e.label || ""} loading="lazy" />
          </ImageFrame>
          {e.label && <ImageCaption>{e.label}</ImageCaption>}
        </ImageCard>
      ))}
    </ImageGallery>
  );
};
